import React, { useState, useContext } from "react";
import { GlobalContext } from "../../../contexts/GlobalContext";
import { sendAnnulmentOperation, updateRemainingQuantity } from "../../../apis/apis.logistics/apisProduct";
import { toast } from "react-toastify";
import { ContextAuth } from "../../../contexts/ContextAuth";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { Badge } from "../../../components/ui";

const thWarm = "bg-purple-700 text-white px-2 py-2 text-xs font-semibold uppercase";
const thInfo = "bg-indigo-600 text-white px-2 py-2 text-xs font-semibold uppercase";
const thSuccess = "bg-blue-500 text-white px-2 py-2 text-xs font-semibold uppercase";
const thDanger = "bg-sky-500 text-white px-2 py-2 text-xs font-semibold uppercase";
const inputClass =
    "w-full rounded border border-gray-300 px-2 py-1 text-center text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white";

function rowClass(item) {
    if (item.operationStatus == "03") return "bg-red-100 dark:bg-red-900/30";
    if (item.operationType == "01") return "bg-amber-50 dark:bg-amber-900/20";
    if (item.operationType == "02") return "bg-blue-50 dark:bg-blue-900/20";
    return "bg-white dark:bg-gray-800";
}

export function InventoryList({
    selectedInventory,
    onOpenOperationModal,
    onOpenSaleModal,
}) {
    const { auth } = useContext(ContextAuth);
    const { setInventories, inventories } = useContext(GlobalContext);
    const [editingIndex, setEditingIndex] = useState(null);
    const [newPrice, setNewPrice] = useState("");

    async function handleClickBtnAnnular(item) {
        if (window.confirm("¿Estás seguro de que deseas anular esta operación?")) {
            await sendAnnulment({
                operationID: item.operationID,
                userID: auth.data.user_id,
            }).then((r) => {
                if (r.status == 201) {
                    toast.success("Operación anulada con éxito!");
                } else {
                    toast.error("Ocurrió algún error");
                }
            });
        }
    }

    const sendAnnulment = async (data) => {
        try {
            return await sendAnnulmentOperation(data);
        } catch (error) {
            throw error;
        }
    };

    const handleDoubleClick = (index) => {
        setEditingIndex(index);
        setNewPrice(inventories[index].remainingQuantity);
    };

    const handleChange = (e) => setNewPrice(e.target.value);

    const saveRemainingQuantity = async (data) => {
        try {
            return await updateRemainingQuantity(data);
        } catch (error) {
            throw error;
        }
    };

    const handleKeyDown = (e, index, pk) => {
        if (e.key === "Enter") {
            const updatedInventories = inventories.map((inventory, i) =>
                i === index
                    ? { ...inventory, remainingQuantity: Number(newPrice) }
                    : inventory
            );
            saveRemainingQuantity({
                inventoryID: Number(pk),
                newRemainingQuantity: Number(newPrice),
            });
            setInventories(updatedInventories);
            setEditingIndex(null);
        }
    };

    const handleBlur = () => setEditingIndex(null);

    return (
        <div className="space-y-4">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div className="flex flex-wrap items-center gap-2 text-sm text-gray-600 dark:text-gray-300">
                    <Badge variant="secondary" className="px-3 py-1">
                        <i className="fas fa-warehouse mr-1" aria-hidden="true" />
                        {selectedInventory.warehouseName || "—"}
                    </Badge>
                    <span className="text-gray-400">/</span>
                    <Badge variant="primary" className="px-3 py-1">
                        <i className="fas fa-box mr-1" aria-hidden="true" />
                        {selectedInventory.productName || "—"}
                    </Badge>
                </div>

                <div className="flex flex-wrap gap-2">
                    {onOpenOperationModal && (
                        <button
                            type="button"
                            onClick={onOpenOperationModal}
                            className="hidden rounded-lg border border-amber-500 px-4 py-2 text-sm font-medium text-amber-600 hover:bg-amber-50 dark:text-amber-400 dark:hover:bg-amber-900/20"
                        >
                            Registrar Operación
                        </button>
                    )}
                    <button
                        type="button"
                        onClick={onOpenSaleModal}
                        className="inline-flex items-center gap-2 rounded-lg bg-amber-500 px-4 py-2 text-sm font-semibold text-gray-900 transition-colors hover:bg-amber-600"
                    >
                        <i className="fas fa-cash-register" aria-hidden="true" />
                        Registrar Venta
                    </button>
                </div>
            </div>

            <div className="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700">
                <table
                    className="w-full min-w-[900px] border-collapse text-center text-xs uppercase"
                    id="table-to-xls"
                >
                    <thead>
                        <tr>
                            <td colSpan={14} className={`${thWarm} text-center`}>
                                {selectedInventory.productName || "Inventario"}
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={5} className={thWarm}>
                                Descripción
                            </td>
                            <td colSpan={3} className={thInfo}>
                                Entrada
                            </td>
                            <td colSpan={3} className={thSuccess}>
                                Salida
                            </td>
                            <td colSpan={3} className={thDanger}>
                                Saldo
                            </td>
                        </tr>
                        <tr>
                            <td className={thWarm}>id</td>
                            <td className={thWarm}>fecha</td>
                            <td className={thWarm}>usuario</td>
                            <td className={thWarm}>tipo de operación</td>
                            <td className={thWarm}>Comprobante</td>
                            <td className={thInfo}>cant</td>
                            <td className={thInfo}>precio unitario</td>
                            <td className={thInfo}>precio total</td>
                            <td className={thSuccess}>cant</td>
                            <td className={thSuccess}>precio unitario</td>
                            <td className={thSuccess}>precio total</td>
                            <td className={thDanger} colSpan={3}>
                                cant restante
                            </td>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                        {inventories.map((item, index) => (
                            <tr key={index} className={rowClass(item)}>
                                <td className="px-2 py-2 normal-case text-gray-900 dark:text-white">
                                    {item.operationID}
                                </td>
                                <td className="px-2 py-2 normal-case">
                                    {item.operationDate}
                                </td>
                                <td className="px-2 py-2 normal-case">
                                    {item.operationUser}
                                </td>
                                <td className="px-2 py-2 normal-case text-left">
                                    {item.operationType == "04" &&
                                    item.operationAction == "S"
                                        ? "TRANSBORDO - ABASTECIMIENTO"
                                        : item.operationTypeDisplay}
                                    : {item.operationDocumentNumber}
                                </td>
                                <td className="px-2 py-2 normal-case">
                                    {item.operationType == "04" &&
                                    item.operationAction == "S"
                                        ? ""
                                        : item.operationType == "02"
                                          ? item.operationClient
                                          : item.operationDocumentNumber}
                                </td>
                                <td className="px-2 py-2 normal-case">
                                    {item.operationAction == "E" ? item.quantity + "" : ""}
                                </td>
                                <td className="px-2 py-2 normal-case">
                                    {item.operationAction == "E"
                                        ? "S/" + item.priceUnit
                                        : ""}
                                </td>
                                <td className="px-2 py-2 normal-case">
                                    {item.operationAction == "E"
                                        ? "S/" + item.priceTotal
                                        : ""}
                                </td>
                                <td className="px-2 py-2 normal-case">
                                    {item.operationAction == "S" ? item.quantity + "" : ""}
                                </td>
                                <td className="px-2 py-2 normal-case">
                                    {item.operationAction == "S"
                                        ? "S/" + item.priceUnit
                                        : ""}
                                </td>
                                <td className="px-2 py-2 normal-case">
                                    {item.operationAction == "S"
                                        ? "S/" + item.priceTotal
                                        : ""}
                                </td>
                                <td className="px-2 py-2 normal-case" colSpan={3}>
                                    {editingIndex === index ? (
                                        <input
                                            type="text"
                                            value={newPrice}
                                            className={inputClass}
                                            onChange={handleChange}
                                            onKeyDown={(e) =>
                                                handleKeyDown(
                                                    e,
                                                    index,
                                                    item.operationDetailID
                                                )
                                            }
                                            onBlur={handleBlur}
                                            onFocus={(e) => e.target.select()}
                                            autoFocus
                                        />
                                    ) : (
                                        <span
                                            className="cursor-pointer font-semibold hover:underline"
                                            onDoubleClick={() =>
                                                handleDoubleClick(index)
                                            }
                                            title="Doble clic para editar"
                                        >
                                            {item.remainingQuantity}
                                        </span>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {inventories.length === 0 && (
                <p className="py-6 text-center text-sm text-gray-500 dark:text-gray-400">
                    <i className="fas fa-search mb-2 text-2xl" aria-hidden="true" />
                    <br />
                    Use los filtros y pulse Buscar para ver movimientos.
                </p>
            )}

            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                className="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700"
                table="table-to-xls"
                filename="report_of_inventory"
                sheet="report"
                buttonText="Descargar como XLS"
            />
        </div>
    );
}
